import React from 'react'
import { Frame } from '@shopify/polaris'
import Routes from "./Routes"

class App extends React.Component {
    constructor(props){
        super(props)
      
    }
  
    render(){
        return (
            <Frame >
                    <Routes />
            </Frame>
        )
    }
}

export default App